import type { Dispatch, FC, ReactNode, SetStateAction } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

export interface LightModeContextType {
  isLightMode: boolean;
  setIsLightMode: Dispatch<SetStateAction<boolean>>;
}

const LightModeContext = createContext<LightModeContextType | undefined>(undefined);

export const LightModeProvider: FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [isLightMode, setIsLightMode] = useState<boolean>(false);
  const value = useMemo(
    () => ({
      isLightMode,
      setIsLightMode
    }),
    [isLightMode, setIsLightMode]
  );

  return <LightModeContext value={value}>{children}</LightModeContext>;
};
export const useLightMode = (): LightModeContextType => {
  const context = useContext(LightModeContext);
  if (context === undefined) {
    throw new Error('useFilter must be used within a FilterProvider');
  }
  return context;
};
